/**
 * Created by Andrey Popov on 5/15/24.
 */

const NoAds = function () {
    this.state = NoAds.STATE_DISABLED;

    this.load();

    connector.ads.on("changeStatus", this.refreshOffer.bind(this));
    connector.ads.on("interstitial:refresh", this.refreshOffer.bind(this));

    this.refreshOffer();
};

NoAds.prototype.load = function () {
    this.state = cleverapps.dataLoader.load(DataLoader.TYPES.NO_ADS) || NoAds.STATE_DISABLED;
};

NoAds.prototype.getState = function () {
    return this.state;
};

NoAds.prototype.refreshOffer = function () {
    cleverapps.offerManager.refreshOffer(Offers.TYPES.NOADS);
};

NoAds.prototype.enable = function (fromServer) {
    this.state = NoAds.STATE_ENABLED;
    if (cleverapps.bannerAd) {
        cleverapps.bannerAd.check(true);
    }
    this.refreshOffer();
    this.save(fromServer);
};

NoAds.prototype.reset = function () {
    this.state = NoAds.STATE_DISABLED;
    if (cleverapps.bannerAd) {
        cleverapps.bannerAd.check(true);
    }
    this.refreshOffer();
    this.save();
};

NoAds.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.NO_ADS, this.state);

    if (!fromServer) {
        connector.synchronizer.addSendTask("noAds");
    }
};

NoAds.prototype.canBuy = function () {
    return connector.payments.getProduct("noAds")
        && this.state === NoAds.STATE_DISABLED
        && connector.ads.isNoAdsProductAvailable()
        && ![AdsLimits.STATE_UNAVAILABLE, AdsLimits.STATE_DISABLED].includes(cleverapps.adsLimits.state(AdsLimits.TYPES.INTERSTITIAL));
};

NoAds.STATE_DISABLED = 0;
NoAds.STATE_ENABLED = 1;

SyncAdapters.noAds = {
    getInfo: () => cleverapps.noAds.getState(),

    updateInfo: (serverData) => {
        if (serverData) {
            cleverapps.noAds.enable(true);
        }
    }
};

SnapshotAdapters.noAds = {
    getInfo: () => cleverapps.noAds.getState(),

    updateInfo: (state) => {
        if (state) {
            cleverapps.noAds.enable();
        } else {
            cleverapps.noAds.reset();
        }
    }
};
